import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withTranslation } from 'react-i18next';
import Increment from "./Increment";
import CurrencyInput from "react-currency-input";
import { initialize } from "../../utils/i18Util";

class CostAddComponent extends Component {
    constructor(props) {
        super(props);
        this.showCostForm = this.showCostForm.bind(this);
        this.deleteCostForm = this.deleteCostForm.bind(this);
        this.setFieldForCostPhotos = this.setFieldForCostPhotos.bind(this);
        this.state = {
            icon: "fa-angle-right",
            display: "none",
            costBrandShow: false,
            costTypeList: [],
            paymentTypeList: [],
            costMoneyTypeList: [],
            kdvOrani: [],
            kdvOraniAktif: false,
            formFieldsAndRequirements: {},
            costDocumentationType:[],
            translatedCostTypes:[],
            translatedPaymentTypes:[],
        }
    }

     componentDidMount() {
        let { costNumber, parent } = this.props;
         parent.state.costFormComponents[(costNumber - 1)].refs =this.refs;
        const employeeInfo = JSON.parse(window.localStorage.getItem('employeeInfo'));
        if (employeeInfo !== null) {
            this.setState({
                costTypeList: employeeInfo.costType,
                paymentTypeList: employeeInfo.paymentType,
                costMoneyTypeList: employeeInfo.costMoneyType,
                kdvOrani: employeeInfo.kdvOrani,
                kdvOraniAktif: employeeInfo.kdvOraniAktif,
                formFieldsAndRequirements: employeeInfo.formFieldsAndRequirements,
                costDocumentationType:employeeInfo.costDocumentationType,
                costBrandShow:employeeInfo.costBrand.length > 0,
            },async () => {
                const { translatedCostTypes, translatedPaymentTypes } = await initialize();
                this.setState({
                    translatedCostTypes: translatedCostTypes,
                    translatedPaymentTypes: translatedPaymentTypes
                });
            });
        }

    }

    showCostForm() {
        if (this.state.display === "none") {
            this.setState({
                display: "block",
                icon: "fa-angle-down"
            });
        } else {
            this.setState({
                display: "none",
                icon: "fa-angle-right"
            });
        }
    }
    deleteCostForm() {
        var { parent, costNumber } = this.props;
        if ((costNumber - 1) != 0) {
            parent.state.costFormComponents[costNumber - 1] = null;
            ReactDOM.findDOMNode(this).remove();
            parent.setState({
                costFormComponents: parent.state.costFormComponents
            });
        }
    }
    setFieldForCostPhotos() {
        this.props.parent.state.costFormComponents[this.props.costNumber - 1].costPhotos = ReactDOM.findDOMNode(this).querySelectorAll(".costPhoto");
    }
    handleOnChange = (event) => {
        if (event.target.value != 'Genel Gider') {
            this.setState({ costBrandShow: true });
        } else {
            this.setState({ costBrandShow: false });
        }
    };
    render() {
        let { costNumber, costTypes, costDocumentationTypes,maxCostTime, parent, kdvOrani, kdvOraniAktif, paymentType, costCategory, costLocation, costBrand,t } = this.props;
        const employeeInfoStr = localStorage.getItem('employeeInfo');
        const employeeInfo = JSON.parse(employeeInfoStr);

        maxCostTime= employeeInfo.employeeMaxCostTime === false ? maxCostTime : employeeInfo.employeeMaxCostTime;
        costBrand= employeeInfo.costBrand;
        costCategory= employeeInfo.costCategory;    
        
        let { display, formFieldsAndRequirements } = this.state;
        var getAllMoney = new window.Money().getAllMoney();
        var getAllMoneyI18nCodes= new window.Money().getAllMoneyI18nCodes()      
        return (
            <div className="card panel-CostAdd">
                <div className="header">
                    <div className="col-md-11 col-xs-10"><h4 className="title"><button onClick={this.showCostForm} className="btn btn-wd actionBtn2 actionBtn" id={"costMenuButton-" + costNumber}><i className={"fa " + this.state.icon}></i></button> &nbsp; {t('cost')} <span ref="cost_number" id={"costNumber-" + costNumber}>{costNumber}</span></h4></div>
                    {
                        costNumber !== 1
                            ?
                            <div className="col-md-1 col-xs-2"><btn className="btn btn-xs btn-danger" onClick={this.deleteCostForm}><i className="fa fa-trash"></i></btn></div>
                            :
                            null
                    }
                </div>
                <div className="content costAddComponent" style={{ display: display }}>
                    <div className="content table-responsive table-full-width">
                        <div className="col-md-6 costAddColumn" id={"addCostCostDate-" + costNumber}>
                            <span className="star">*</span><label>{t('costDate')}</label>
                            <input type="date" id={"addCostCostDateInput-" + costNumber} onBlur={(e) => {
                                this.props.onChangeDate(e,maxCostTime, parent.state.costFormComponents[0].refs.costDate.value || 0, e.target.value);
                            }} defaultValue="" ref="costDate" className="form-control border-input" placeholder={t('costDate')}/>
                        </div>
                        <div className="col-md-6 costAddColumn" id={"addCostInvoiceNo-" + costNumber}>
                            <span className="star">*</span><label>{t('invoiceReceiptNo')}</label>
                            <input type="text" defaultValue="" id={"addCostInvoiceNoInput-" + costNumber} ref="invoiceNo" className="form-control border-input" placeholder={t('invoiceNo')} />
                        </div>
                        {this.state.costDocumentationType && this.state.costDocumentationType.length >0 ?
                            (  <div className="col-md-6 costAddColumn" id={"addCostDocumentationType-" + costNumber}>
                                <span className="star">*</span><label>{t('costDocumentationType')}</label>
                                <select className="form-control border-input" defaultValue="" id={"addCostDocumentationTypeInput-" + costNumber} ref="costDocumentationType">
                                    <option value="-1">{t('selectCostDocumentationType')}</option>
                                    {
                                        this.state.costDocumentationType.map((data, key) => {
                                            return <option value={data.type} key={key}>{data.type}</option>
                                        })
                                    }
                                </select>
                            </div>):null}
                        <div className="col-md-6 costAddColumn" id={"addCostCostType-" + costNumber}>
                            <span className="star">*</span><label>{t('costType')}</label>
                            <select className="form-control border-input" defaultValue="" id={"addCostCostTypeInput-" + costNumber} ref="costType">
                                <option value="-1">{t('selectAnCostType')}</option>
                                { this.props.i18n.language === "tr" ?
                                    this.state.costTypeList.map((data, key) => {
                                        return <option value={data.type} key={key}>{data.type}</option>
                                    }):
                                    this.state.translatedCostTypes.map((data, key) => {
                                        return <option value={data.type} key={key}>{data.type}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-md-6 costAddColumn" id={"addCostCostAmount-" + costNumber} >
                            <span className="star">*</span><label>{t('costAmount')} </label>
                            <CurrencyInput value={this.refs.costAmount ? this.refs.costAmount.state.value : 0} id={"addCostCostAmountInput-" + costNumber} className="form-control border-input" placeholder={t('costAmount')} ref="costAmount" />
                        </div>
                        {
                            (costLocation && costLocation.length > 0) ?
                                <div className="col-md-6 costAddColumn" id={"addCostCostLocationType-" + costNumber} >
                                    <span className="star">*</span><label>{t('costKind')}</label>
                                    <select className="form-control border-input" defaultValue="" id={"addCostCostLocationTypeInput-" + costNumber} ref="costLocation">
                                        <option value="-1">Masraf tipi seçin.</option>
                                        {
                                            costLocation.map((data, key) => {
                                                return <option value={data.type} key={key}>{data.type}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        {
                            (costCategory && costCategory.length > 0) ?
                                <div className="col-md-6 costAddColumn" id={"addCostCostCategoryType-" + costNumber}>
                                    <span className="star">*</span><label>{t('costCategory')}</label>
                                    <select className="form-control border-input" defaultValue="" id={"addCostCostCategoryTypeInput-" + costNumber} ref="costCategory" onChange={this.handleOnChange}>
                                        <option value="-1">{t('selectCostCategory')}</option>
                                        {
                                            costCategory.map((data, key) => {
                                                return <option value={data.type} key={key}>{data.type}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        {
                            (costBrand && costBrand.length > 0) && this.state.costBrandShow ?

                                <div className="col-md-6 costAddColumn" id={"addCostCostBrandType-" + costNumber} >
                                    <span className="star">*</span><label>{this.state.costDocumentationType.length > 0 ? t('costDepartment') : t('costBrand')}</label>

                                    <select className="form-control border-input" id={"addCostCostBrandTypeInput-" + costNumber} defaultValue="" ref="costBrand">
                                        <option value="-1">{this.state.costDocumentationType.length > 0 ? t('selectCostDepartment') : t('selectCostBrand')}</option>
                                        {
                                            costBrand.map((data, key) => {
                                                return <option value={data.type} key={key}>{data.type}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        
                        <div className="col-md-6 costAddColumn" id={"addCostMoneyType-" + costNumber}>
                            <span className="star">*</span><label>{t('currencyUnit')}</label>
                            <select className="form-control border-input" defaultValue="TL" id={"addCostMoneyTypeInput-" + costNumber} ref="moneyType">
                            <option value="-1">{t('selectCurrencyUnit')}</option>
                                {
                                    this.state.costMoneyTypeList.map((data, key) => {
                                       return <option value={data.type}  key={key}>({getAllMoney[data.type]}) {t(getAllMoneyI18nCodes[data.type])}</option>
                                    })
                                }                               
                            </select>
                        </div>
                        <div className="col-md-6 costAddColumn" id={"addCostPaymentType-" + costNumber}>
                            <span className="star">*</span><label>{t('paymentType')} </label>
                            <select className="form-control border-input" defaultValue="" id={"addCostPaymentTypeInput-" + costNumber} ref="paymentType">
                                <option value="-1">{t('selectPaymentType')}</option>
                                {  this.props.i18n.language === "tr" ?
                                    this.state.paymentTypeList.map((data, key) => {
                                        return <option value={data.type} key={key}>{data.type}</option>
                                    }):
                                    this.state.translatedPaymentTypes.map((data, key) => {
                                        return <option value={data.type} key={key}>{data.type}</option>
                                    })
                                }
                            </select>
                        </div>
                        {
                            kdvOraniAktif === "true"
                                ?
                                <div className="col-md-6 costAddColumn" id={"addCostKDVRatio-" + costNumber} >
                                    <span className="star">*</span><label>{t('vatRate')}</label>
                                    <select className="form-control border-input" defaultValue="" id={"addCostKDVRatioInput-" + costNumber} ref="kdvOrani">
                                        <option value="-1">{t('selectVatRate')}</option>
                                        {
                                            (this.state.kdvOrani || []).map((data, key) => {
                                                return <option value={data.type} key={key}>{data.type}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                :
                                null
                        }
                        <div className="col-md-12 costAddColumn" id={"addCostSupplierName-" + costNumber}>
                            <span className="star">*</span><label>{t('supplierName')} </label>
                            <input type="text" defaultValue="" ref="supplierName" id={"addCostSupplierNameInput-" + costNumber} className="form-control border-input" placeholder={t('supplierName')} />
                        </div>
                        <div className="col-md-12 costAddColumn" id={"addCostCostDescription-" + costNumber} >
                            <span className="star">*</span><label>{t('description')}</label>
                            <textarea ref="costDescription" defaultValue="" id={"addCostCostDescriptionInput-" + costNumber} placeholder={t('enterProvinceAndReasonForExpense')} className="form-control border-input"></textarea>
                        </div>
                            <Increment t={t} costNumber={costNumber} setCostPhoto={this.setFieldForCostPhotos} required={formFieldsAndRequirements.costPhoto} />
                    </div>
                </div>
            </div>
        );
    }

 
}

export default withTranslation()(CostAddComponent);